module.exports = __webpack_public_path__ + "static/media/toy-train.f597465b.mov";